import { css } from '@emotion/react';
import { CSSProperties } from 'react';
import theme from '../../theme';

export const gridStyles = css`

`;

export const styles = (): Record<string, CSSProperties> => ({
  root: {
    height: '100%',
    width: '100%'
  }
});
